import { HTTP, HTTP_UN_INTERCEPTED } from "config/http-axios.js";

const HTTP_GET = "GET";
const HTTP_POST = "POST";
const HTTP_PUT = "PUT";
const HTTP_PATCH = "PATCH";
const HTTP_DELETE = "DELETE";

class ApiBaseService {
  static request(endpoint, method, payload, headers = {}, isUnIntercepted) {
    const isFormData = payload instanceof FormData;

    // Handle Content-Type header
    if (isFormData) {
      // FormData sets Content-Type automatically with boundary, so remove if manually set
      delete headers["Content-Type"];
    } else if (!headers["Content-Type"]) {
      // Default to JSON for non-FormData payloads
      headers["Content-Type"] = "application/json";
    }

    const http = isUnIntercepted ? HTTP_UN_INTERCEPTED : HTTP;

    return new Promise(async (resolve, reject) => {
      try {
        let response;
        switch (method) {
          case HTTP_GET:
            response = await http.get(endpoint, { headers });
            break;
          case HTTP_POST:
            response = await http.post(endpoint, payload, { headers });
            break;
          case HTTP_PUT:
            response = await http.put(endpoint, payload, { headers });
            break;
          case HTTP_PATCH:
            response = await http.patch(endpoint, payload, { headers });
            break;
          case HTTP_DELETE:
            response = await http.delete(endpoint, { data: payload, headers });
            break;
          default:
            console.error("Wrong HTTP method requested");
        }
        resolve(response);
      } catch (error) {
        reject(error.response);
      }
    });
  }
}

export default ApiBaseService;
